import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './VodList.css'
import { DailyVodConfig, VideoType } from '../../../configs/stream-entities'

class VodListProps {
    public isMultiple: boolean = false
    public defaultValue: string = ''
    public onItemSelected: (doc: DailyVodConfig) => void
}

class VodListState {
    public types: string[] = []
    public defaultValue: string = '-1'
}

class VodList extends React.Component<VodListProps, VodListState> {
    private classTypeIdList: string[] = []
    private classTypeList: DailyVodConfig[] = []
    private observer: firebase.Unsubscribe

    constructor(props: VodListProps) {
        super(props)
        const newState = new VodListState()
        newState.defaultValue = this.props.defaultValue
        this.state = newState
        this.onItemSelected = this.onItemSelected.bind(this)
        this.populateList = this.populateList.bind(this)
        this.refreshList = this.refreshList.bind(this)
    }

    public componentWillMount() {
        this.populateList(null)
    }

    public componentWillUnmount() {
        if(this.observer !== null) {
            this.observer()
        } 
    }

    public render() {
        return (
            <div className="VodList" >
                <input name="type" type="radio" id="typeALL" value="" onChange={this.refreshList}/><label htmlFor="typeALL">ALL</label><br />
                <input name="type" type="radio" id="typeDJ" value={VideoType.DAILY} onChange={this.refreshList}/><label htmlFor="typeDJ">DAILY JOURNEY</label><br />
                <input name="type" type="radio" id="typeVOD" value={VideoType.EVERYDAY} onChange={this.refreshList} /><label htmlFor="typeVOD">VOD</label>
                <select onChange={this.onItemSelected} multiple={this.props.isMultiple} value={this.props.isMultiple ? [this.getSelectDefaultValue()] : this.getSelectDefaultValue()}>
                    <option value="-1">Select a Video</option>
                    {this.state.types.map((q, i) =>
                        <option key={i} value={i}>{q}</option>
                    )}
                </select>
            </div>)
    }

    private refreshList(event: React.ChangeEvent<HTMLInputElement>) {
        const type = VideoType[event.target.value]
        if (type !== undefined) {
            this.populateList(type)
        } else {
            this.populateList(null)
        }
    }

    private populateList(type: VideoType | null) {
        console.log(type)
        let baseRequest = firebase.firestore().collection('vod').doc("daily").collection('videos').orderBy('publishDate', 'desc')
        if (type !== null) {
            baseRequest = baseRequest.where('type', '==', type)
        }
        this.setState({types: []})
        this.classTypeList = []
        this.classTypeIdList = []

        this.observer = baseRequest.onSnapshot(snapshot => {
            snapshot.docChanges().forEach(query => {
                const newClass = new DailyVodConfig()
                const t = query.doc.data()!.publishDate.seconds * 1000
                Object.assign(newClass, query.doc.data())
                newClass.publishDate = new Date(t)
                newClass.id = query.doc.id

                if (this.classTypeIdList.indexOf(query.doc.id) > -1) {
                    const index = this.classTypeIdList.indexOf(query.doc.id)
                    this.state.types[index] = newClass.type === VideoType.EVERYDAY ?
                        newClass.description :
                        newClass.publishDate.toLocaleDateString() + " " + (newClass.description || "")
                } else {
                    this.classTypeIdList.push(newClass.id)
                    this.classTypeList.push(newClass)
                    this.state.types.push(newClass.type === VideoType.EVERYDAY ?
                        newClass.description :
                        newClass.publishDate.toLocaleDateString() + " " + (newClass.description || "") )
                }
                this.setState(this.state)
            })
        })
    }

    private getSelectDefaultValue(): string {
        for (let i = 0; i < this.classTypeList.length; i++) {
            if (this.classTypeList[i].id === this.state.defaultValue) {
                return String(i)
            }
        }
        return '-1'
    }

    private onItemSelected(event: React.ChangeEvent<HTMLSelectElement>) {
        const index = Number(event.currentTarget.value)
        if (index > -1) {
            const doc = this.classTypeList[index]
            this.props.onItemSelected(doc)
            this.setState({ defaultValue: doc.id })
        }
    }

}

export default VodList


// WEBPACK FOOTER //
// ./src/components/daily-video/vod-list/VodList.tsx